<template>
  <div class="ms-datepicker ms-editor w-100" ref="refWrap" :class="[{'ms-validate': isValidate}]">
    <label class="label" v-if="label">{{ label }}</label>
    <div
      ref="refParent"
      class="ms-container--datepicker flex-row"
      :class="[{error: errorMessage, disabled: disabled}, hasBorder ? 'border' : '']"
    >
      <input
        ref="input"
        class="ms-input--datepicker flex"
        :value="rawValue"
        :tabindex="0"
        :autofocus="autofocus"
        :disabled="disabled"
        :class="[{disabled: disabled}, hasBorder ? dbOptionHeight + '-border' : dbOptionHeight]"
        :readOnly="readOnly"
        v-on="listeners"
      />
      <div
        ref="icon"
        @click="toggleClick"
        :class="[
          heightOption == 2
            ? isFilterGrid == true
              ? 'ms-calendar-filter-grid'
              : 'ms-calendar'
            : isFilterGrid == true
            ? 'ms-calendar-small-filter-grid'
            : 'ms-calendar-small',
          {disabled: disabled},
          {'event-none': readOnly},
        ]"
        v-if="!onlyDisplayTime"
        :title="tooltipIcon"
      ></div>
    </div>

    <slot :errorMessage="errorMessage" name="error"></slot>
    <div class="error-text" v-if="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="datepicker-content" ref="datepickerContent">
      <!-- :style="{ top: top, left: left, width: width, height: height }" -->
      <datepicker
        :screenX="0"
        :screenY="0"
        class="datepicker"
        ref="datepicker"
        v-model="valueDatePicker"
        :format="format"
        :min="min"
        :max="max"
        @close.stop="updateDatePicker"
        @hide.stop="isShowDatePicker = false"
        @dateInput="updateTime"
        v-if="isShowDatePicker"
        :hasTime="hasTimeInfo"
      ></datepicker>
      <!-- @close="updateDatePicker" -->
      <!-- :hasTime="hasTimeInfo" -->
    </div>
  </div>
</template>

<script>
`use strict`;
import Datepicker from './Datepicker.vue';
import {IMaskDirective} from 'vue-imask';
import IMask from 'imask';
import msDateUtil from './msDateUtil';
import moment from 'moment';
import msBaseComponent from '@/components/base/MsBaseComponent.vue';
import {ModuleContext} from '@/stores/moduleConst';
import {mapGetters} from 'vuex';
import {useValidateControl} from '@/setup/validateControl.js';
import EventBusGlobal, {GlobalEventName} from '@/commons/eventBusGlobal';

/**
 * Regular kiểm tra có sử dụng thông tin giờ không?
 */
let regHourInfo = /[aAhHksSZ]/;

export default {
  name: 'MsDatepicker',
  extends: msBaseComponent,
  // inheritAttrs: false,
  // extends: MsBaseComponent,
  props: {
    autofocus: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      required: false,
      // default: new Date(),
    },

    /**
     * Theo chuẩn của momentJS
     * VD: Nếu có full datetime:
     *  - DD/MM/YYYY kk:mm:ss (20/01/2020 15:03:45)
     *  - DD/MM/YYYY kk:mm:ss A (20/01/2020 15:03:45)
     */
    format: {
      type: String,
      default: 'DD/MM/YYYY',
    },

    /**
     * Loại date picker
     * @values 'secondary'
     * Created by: pvduong1 - 15/10/2019
     */
    type: {
      type: String,
      default: '',
    },
    defaultTime: {
      type: String,
      default: null,
    },
    min: {},
    max: {},
    /*
     * Hàm show ra câu thông báo riêng theo từng trường hợp
     * pvduy 18/03/2021
     * ví dụ: customWarring {rules:'required', mes: 'Tài sản này là của pvduy'}
     */
    customWarring: {
      type: Object,
      default: null,
    },
    // Xác định xem input có border hay không?
    hasBorder: {
      default: true,
      type: Boolean,
    },

    // Xác định là dùng ở filer header grid
    isFilterGrid: {
      type: Boolean,
      default: false,
    },
    hasTimeInfo: {
      type: Boolean,
      default: false,
    },
    onlyDisplayTime: {
      type: Boolean,
      default: false,
    },
    setToCurrentDateTime: {
      type: Boolean,
      default: false,
    },
    /**
     * Có hiển thị icon chọn ngày không
     * NHANH3 14.08.2023
     */
    showIconDate: {
      type: Boolean,
      default: true,
    },
    tooltipIcon: {
      type: String,
      default: null,
    },
  },

  computed: {
    ...mapGetters(ModuleContext, ['ConfigInfo']),
    listeners() {
      return {
        input: e => {
          if (e.target.value == '_/__/____' || e.target.value == '__/__/____' || !e.target.value) {
            this.$nextTick(() => {
              this.updateVModel(null);
            });
          }
        },
        change: e => {
          this.onChange(e);
        },
        focus: e => {
          this.onFocus(e);
        },
        blur: e => {
          this.onBlur(e);
        },
        keydown: e => {
          this.$emit(this.$ms.constant.CustomEvent.MsKeydown, e);
        },
        focus: e => {
          this.momentMask.updateOptions({lazy: false});
          this.isShowDatePicker = false;
        },
        focusout: e => {
          this.momentMask.updateOptions({lazy: true});
        },
      };
    },
    /**
     * Độ rộng của input
     */
    dbOptionHeight() {
      return 'heightoptionvalue' + parseInt(this.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    },

    heightOption() {
      return this.$store?.state?.dbOption?.dbOptions.HeightOption || 2;
    },
  },

  watch: {
    modelValue: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        if (typeof newVal == 'string') {
          let newValDate = newVal?.getDateOnly();
          me.updateVModel(newValDate, oldVal, undefined, me.$ms.constant.CallbackType.Model);
        } else {
          me.setRawValue(newVal);
          me.$emit('update:modelValue', newVal);
        }
      },
    },
    min: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        if (newVal) {
          me.updateMomentMask();
        }
      },
    },
    isShowDatePicker: {
      handler(newVal, oldVal) {
        const me = this;
        me.handleToggle(newVal);
      },
    },
  },

  data() {
    return {
      topx: 0,
      leftx: 0,
      focused: false,
      rawValue: '',
      valueDatePicker: this.modelValue ? this.modelValue : new Date(), // ngày thao tác với datepicker popup, định dạng Date
      isShowDatePicker: false,
    };
  },

  components: {
    Datepicker,
    // ValidationProvider
  },

  methods: {
    getValue() {
      return this.modelValue;
    },
    /**
     * Thiết lập mesage khi dữ liệu rỗng
     *
     * Created by: pvduong1 - 18/09/2019
     * pvduy 14/05/2021: thêm đoạn xử lý kiểm tra trống mes thì ẩn cảnh báo.
     */
    setError(message) {
      const me = this;
      setTimeout(() => {
        if (message) {
          me.errorProvider['isValid'] = true;
          me.errorProvider['message'] = message;
          me.errorProvider['element'] = this;
        } else {
          me.errorProvider['isValid'] = false;
        }

        // me.$refs.provider.applyResult({
        // 	errors: [message],
        // 	valid: false,
        // 	failedRules: {},
        // });
      });
    },
    setDefaultTime(value) {
      const me = this;
      if (me.defaultTime && value) {
        let splitTime = me.defaultTime.split(':');
        if (splitTime && splitTime.length == 3) {
          value.setHours(splitTime[0]);
          value.setMinutes(splitTime[1]);
          value.setSeconds(splitTime[2]);
        }
      }
    },
    /**
     * Tự đọng cập nhật ngày khi control đang nhập dở ngày
     */
    autoNomalizeValue(value, masked) {
      const me = this;
      if (!masked.unmaskedValue) {
        me.updateVModel(me.setToCurrentDateTime ? new Date() : null, me.modelValue, false);
      } else if (value && typeof value == 'string' && masked) {
        if (!masked.isComplete && !masked.date) {
          let dte = me.nomalizeDateTime(value, masked);
          if (dte) {
            me.momentMask.value = msDateUtil.parseDateTimeToString(dte, me.format);
          }
          return dte;
        } else {
          return me.nomalizeDateTime(value, masked);
        }
      }
      return null;
    },

    /**
     * Cập nhật string vào control input phục vụ hiển thị
     */
    setRawValue(valueDte, force) {
      const me = this;
      // if (!me.typing || force) {
      // if (!valueDte) valueDte = me.innerValue;
      if (valueDte) {
        let ret = msDateUtil.parseDateTimeToString(this.hasTimeInfo ? valueDte : valueDte?.getDateOnly(), me.format);
        if (me.rawValue !== ret) {
          me.rawValue = ret;
        }
      } else {
        me.rawValue = null;
      }

      // bnduc: Nếu me.rawValue giá trị thì mới update
      //NCPHUOC: Thực hiện update về giá trị rỗng cho rawValue để hiển thị
      if (me.momentMask && me.momentMask.value != me.rawValue) {
        if (!me.rawValue) {
          me.momentMask.value = '';
        } else {
          me.momentMask.value != me.rawValue && (me.momentMask.value = me.rawValue);
        }
      }
      // }
    },

    /**
     * Thực hiện chuẩn hóa DateTime từ string
     * @param {String/DateTime} str Chuỗi DateTime cần chuẩn hóa
     * @param {MaskedDate} masked Chuỗi DateTime cần chuẩn hóa
     */
    nomalizeDateTime(str, masked) {
      const me = this;
      try {
        if (str) {
          if (str instanceof Date) {
            return str;
          } else {
            if (masked && masked.rawInputValue) {
              let mo = masked.parse(masked.rawInputValue);
              if (mo && mo.isValid()) {
                let dte = mo.toDate(),
                  now = new Date();
                if (me.hasTimeInfo) {
                  const splitDateTime = str.split(' ');
                  if (splitDateTime && Array.isArray(splitDateTime) && splitDateTime.length > 0) {
                    const time = splitDateTime[1] || splitDateTime[0];
                    if (time.includes('__') || time.includes('_')) {
                      if (me.defaultTime) {
                        let splitTime = me.defaultTime.split(':');
                        if (splitTime && splitTime.length == 3) {
                          dte.setHours(splitTime[0]);
                          dte.setMinutes(splitTime[1]);
                          dte.setSeconds(splitTime[2]);
                        }
                      } else {
                        dte.setHours(now.getHours());
                        dte.setMinutes(now.getMinutes());
                        dte.setSeconds(now.getSeconds());
                        dte.setMilliseconds(now.getMilliseconds());
                      }
                    }
                  }
                }
                // if (me.hasTimeInfo && dte && dte.getHours() == 0) {
                //   if (me.defaultTime) {
                //     let splitTime = me.defaultTime.split(':');
                //     if (splitTime && splitTime.length == 3) {
                //       dte.setHours(splitTime[0]);
                //       dte.setMinutes(splitTime[1]);
                //       dte.setSeconds(splitTime[2]);
                //     }
                //   } else {
                //     dte.setHours(now.getHours());
                //     dte.setMinutes(now.getMinutes());
                //     dte.setSeconds(now.getSeconds());
                //     dte.setMilliseconds(now.getMilliseconds());
                //   }
                // }

                if (dte < masked.min || dte > masked.max) {
                  dte.setFullYear(now.getFullYear());
                }

                return dte;
              }
            }
          }
        }
      } catch (ex) {
        me.$ms.log.handleException(ex);
      }
    },

    onFocus(e) {
      this.focused = true;
    },
    onBlur(e) {
      this.focused = false;
      this.$nextTick(() => {
        this.validate();
        // DMNGOC 26/09/2022: sửa lỗi blur khi nhập ngày không hợp lệ
        this.setRawValue(this.modelValue, null);
        this.$emit('onBlurActionDatePicker', e);
      });
    },

    // onInputClick() {
    // 	// this.selectAllTextWhenClick(this.$refs.input);
    // },
    toggleClick(e) {
      const me = this;

      //disable thì không làm gì
      if (me.disabled) {
        return;
      }

      me.isShowDatePicker = !me.isShowDatePicker;
      me.setPickerDisplay('.datepicker-content', true);
      me.updatePositionDropdownMenu();
    },
    /**
     * ẩn picker đi
     */
    setPickerDisplay(selector, value) {
      let pickers = document.querySelectorAll(selector);
      if (pickers && pickers.length > 0) {
        for (let i = 0; i < pickers.length; i++) {
          pickers[i].hidden = !value;
        }
      }
    },
    //Cập nhật lại tọa độ của dropdown menu
    //Created by LTDAT(13.06.2020)
    updatePositionDropdownMenu() {
      const me = this;
      let rectDropdownMenu = me.$refs.datepickerContent.getBoundingClientRect(),
        rectIcon = me.$refs.icon.getBoundingClientRect(),
        windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      let widthDropdown = rectDropdownMenu.width ? rectDropdownMenu.width : 300;
      let heightDropdown = rectDropdownMenu.height ? rectDropdownMenu.height : 300;
      if (rectIcon.left + widthDropdown > windowWidth) {
        me.$refs.datepickerContent.style.left = rectIcon.right - widthDropdown + 10 + 'px';
        // me.$refs.square.style.right = '5px';
      } else {
        me.$refs.datepickerContent.style.left = rectIcon.left + 10 + 'px';
        // me.$refs.square.style.right = 'unset';
      }
      if (rectIcon.bottom + heightDropdown > windowHeight) {
        me.$refs.datepickerContent.style.top = rectIcon.top - heightDropdown + 'px';
      } else {
        me.$refs.datepickerContent.style.top = rectIcon.top + 5 + 26 + 'px';
      }
    },
    onChange(e) {
      // this.inputIsFocus = false;
      const me = this,
        momentMask = me.momentMask,
        masked = momentMask ? momentMask.masked : null,
        value = e.currentTarget.value;
      /**
       * Chốt chặn xử lý auto Gen ngày tháng theo text đang nhập dở
       */
      let newVal = me.autoNomalizeValue(value, masked);

      me.$nextTick(() => {
        if (newVal) {
          if (me.min && newVal.getTime() < me.min.getTime()) {
            newVal = me.min?.getDateOnly();
          } else {
            me.updateVModel(newVal);
          }
          me.$emit('updateDatePicker', newVal);
        }
      });
      if (me.rules) {
        me.validate(me);
      }
      //Đoạn này emit change ko cần thiết do trong updateVModel đã emit
      // this.$emit('msChange', newVal, me.oldDate);
      // this.typing = false;
    },
    /**
     * Sự kiện chọn từ popup DatePicker
     */
    updateDatePicker(e) {
      const me = this;
      //esc
      if (e && e.which == 27) {
        e.cancel = true;
      }
      me.isShowDatePicker = false;
      let value = me.valueDatePicker;
      if (me.format == 'DD/MM/YYYY') {
        if (value instanceof Date) {
          value.setHours(0);
          value.setMinutes(0);
          value.setSeconds(0);
        }
      }
      me.updateVModel(value);
      me.$emit('updateDatePicker', value);
      me.$refs.input.focus();
    },

    /**
     * Xử lý cập nhật vào v-model nếu đã hoàn thành việc nhập liệu
     */
    maskInputComplete() {
      const me = this,
        momentMask = me.momentMask,
        masked = momentMask ? momentMask.masked : null;

      if (masked && masked.isComplete && masked.date) {
        let ret = masked.date.toDate(),
          retText = msDateUtil.parseDateTimeToString(ret, me.format),
          currentValue = msDateUtil.parseDateTimeToString(me.modelValue, me.format);
        // if (retText != currentValue) {
        me.updateVModel(ret, me.modelValue, true);
        // }
      }
    },

    updateTime(newVal) {
      this.$emit('update:modelValue', newVal);
    },

    /**
     * Thực hiện gán value vào MsDatePicker
     * @param {Date} newVal Giá trị cần cập nhật
     * @param {Date} oldVal Giá trị cũ
     * @param {Boolean} changeBinding Thay đổi do binding 2 chiều
     * @param {Boolean} callbackType Callback từ đâu (Xử lý cho TH gọi từ watch model)
     * @private
     */
    updateVModel(newVal, oldVal, changeBinding = true, callbackType) {
      const me = this;
      if (newVal) {
        me.valueDatePicker = newVal;
      } else {
        me.valueDatePicker = new Date();
      }
      me.setRawValue(newVal);
      if (changeBinding) {
        me.$emit('msChange', newVal, me.oldDate, callbackType);
      }
      me.$emit('update:modelValue', newVal);

      /** Xử lý sau khi cập nhật model */
      if (changeBinding && me.$ms.commonFn.compareDate(newVal, oldVal)) {
        me.$emit('afterChange', newVal, me.oldDate, callbackType);
      }

      me.$nextTick(() => {
        if (me.rules) {
          me.validate(me);
        }
        this.$emit('msChangeData', newVal);
      });
    },
    setValue(value) {
      const me = this;
      if (value) {
        me.valueDatePicker = value;
        me.oldDate = me.valueDatePicker?.getDateOnly();
      } else {
        me.valueDatePicker = new Date();
        me.oldDate = null;
      }
      if (typeof value == 'string') {
        let newValDate = value?.getDateOnly();
        me.updateVModel(newValDate, me.modelValue, false);
      } else {
        me.updateVModel(value, me.modelValue, false);
      }
    },
    initPicker() {
      const me = this;
      document.body.appendChild(me.$refs.datepickerContent);
      let element = me.$refs.input,
        momentFormat = me.format,
        momentMask = IMask(element, {
          mask: Date,
          pattern: momentFormat,
          lazy: true,
          min: this.min || new Date(1970, 0, 1), // Sửa lại giới hạn ngày theo tài liệu
          max: this.max || new Date(9998, 12, 31),
          // autofix: true,

          format: function (date) {
            let ret = moment(date).format(momentFormat);
            return ret;
          },
          parse: function (str) {
            let ret = moment(str, momentFormat);
            return ret;
          },

          commit: me.momentMaskCommit,

          blocks: {
            YYYY: {
              mask: IMask.MaskedRange,
              from: 1,
              to: 9999,
            },
            MM: {
              mask: IMask.MaskedRange,
              from: 1,
              to: 12,
            },
            DD: {
              mask: IMask.MaskedRange,
              from: 1,
              to: 31,
              //maxLength: 2
            },
            HH: {
              mask: IMask.MaskedRange,
              from: 0,
              to: 23,
              //maxLength: 2
            },
            kk: {
              mask: IMask.MaskedRange,
              from: 0,
              to: 23,
              //maxLength: 2
            },
            mm: {
              mask: IMask.MaskedRange,
              from: 0,
              to: 59,
              //maxLength: 2
            },
            ss: {
              mask: IMask.MaskedRange,
              from: 0,
              to: 59,
              //maxLength: 2
            },
            A: {
              mask: IMask.MaskedEnum,
              enum: ['AM', 'PM', 'SA', 'CH'],
            },
            a: {
              mask: IMask.MaskedEnum,
              enum: ['am', 'pm', 'sa', 'ch'],
            },
          },
        });

      momentMask.on('complete', me.maskInputComplete);

      me.momentMask = momentMask;
    },
    /**
     * Cập nhật lại option min,max của momentMask
     * tbngoc 30.07.2022
     */
    updateMomentMask() {
      let me = this;
      let option = {
        min: me.min || new Date(1970, 0, 1), // Sửa lại giới hạn ngày theo tài liệu
        max: me.max || new Date(9999, 12, 31),
      };
      if (me.momentMask) {
        me.momentMask.updateOptions(option);
      }
    },
    handleToggle(show) {
      let me = this;

      if (show) {
        me.$nextTick(() => {
          EventBusGlobal.$emit(GlobalEventName.openWrapper, {
            container: [me.$refs.datepicker?.$el],
            element: me.$el,
            button: me.$refs.icon,
          });
        });

        setTimeout(() => {
          EventBusGlobal.$on(GlobalEventName.openWrapper, me.openWrapperOther);
        }, 0);
      } else {
        EventBusGlobal.$off(GlobalEventName.openWrapper, me.openWrapperOther);
      }
    },
    openWrapperOther({container, element, button}) {
      let cont = container || [];

      if (element == this.$el) {
        return;
      }

      this.$nextTick(() => {
        this.isShowDatePicker = false;
      });
    },
  },
  setup(props) {
    const {errorMessage, validate, isValidate} = useValidateControl({
      props,
    });
    return {errorMessage, validate, isValidate};
  },

  mounted() {
    const me = this;

    me.initPicker();
  },

  created() {
    const me = this;
  },

  beforeUnmount() {
    const me = this;
    me.isShowDatePicker = false;

    if (me.$refs.datepicker) {
      me.$refs.datepicker.$el.remove();
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsDatePicker.scss';
</style>
